/* Biotite Skin — Theme JavaScript */

(function() {
  'use strict';

  /* ── CART AJAX ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-cta[data-product-id]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id), quantity: 1 })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.textContent = 'Added!';
      setTimeout(function() {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 1500);
      /* Update cart count */
      return fetch('/cart.js');
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var pills = document.querySelectorAll('.cart-pill');
      pills.forEach(function(pill) {
        pill.textContent = 'Cart (' + cart.item_count + ')';
      });
    })
    .catch(function() {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
    });
  });

  /* ── MOBILE MENU ── */
  (function() {
  'use strict';

  function initMobileMenu() {
    var btn   = document.getElementById('mobile-menu-btn');
    var menu  = document.getElementById('mobile-menu');
    var close = document.getElementById('mobile-menu-close');
    if (!btn || !menu) return;
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      menu.style.display = menu.style.display === 'flex' ? 'none' : 'flex';
    });
    if (close) close.addEventListener('click', function() { menu.style.display = 'none'; });
    document.addEventListener('click', function(e) {
      if (menu.style.display === 'flex' && !menu.contains(e.target) && e.target !== btn) menu.style.display = 'none';
    });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') menu.style.display = 'none'; });
  }

  function initCart() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-cta[data-product-id]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      btn.textContent = 'Adding...'; btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id: parseInt(id), quantity: 1}) })
      .then(function(r) { return r.json(); })
      .then(function() { btn.textContent = 'Added!'; setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500); return fetch('/cart.js'); })
      .then(function(r) { return r.json(); })
      .then(function(cart) { document.querySelectorAll('.cart-pill').forEach(function(p) { p.textContent = 'Cart (' + cart.item_count + ')'; }); })
      .catch(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; });
    });
  }

  function init() {
    initMobileMenu();
    initCart();
    var header = document.querySelector('.site-header');
    if (header) window.addEventListener('scroll', function() { header.style.boxShadow = window.scrollY > 10 ? '0 1px 24px rgba(0,0,0,0.06)' : 'none'; }, {passive:true});
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

  /* ── HEADER SCROLL SHADOW ── */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 1px 24px rgba(0,0,0,0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* ── PRODUCT VARIANT SELECT ── */
  var variantSelect = document.querySelector('#product-form select[name="id"]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      var priceEl = document.querySelector('.product-page-info .product-price');
      var selectedOption = this.options[this.selectedIndex];
      if (priceEl && selectedOption) {
        /* Price update handled server-side on full page; this is a no-op placeholder */
      }
    });
  }

})();
